export enum ECountry {
  GERMANY = 'DE',
  AUSTRIA = 'AT',
  SWITZERLAND = 'CH',
  ALBANIA = 'AL',
  ANDORRA = 'AD',
  ARGENTINA = 'AR',
  AUSTRALIA = 'AU',
  BAHAMAS = 'BS',
  BARBADOS = 'BB',
  BELARUS = 'BY',
  BELGIUM = 'BE',
  BERMUDA = 'BM',
  BOSNIA = 'BA',
  BRAZIL = 'BR',
  BULGARIA = 'BG',
  CANADA = 'CA',
  CAYMAN_ISLANDS = 'KY',
  CROATIA = 'HR',
  CZECHIA = 'CZ',
  DENMARK = 'DK',
  ESTONIA = 'EE',
  FINLAND = 'FI',
  FRANCE = 'FR',
  GREECE = 'GR',
  HUNGARY = 'HU',
  IRELAND = 'IE',
  ITALY = 'IT',
  JAPAN = 'JP',
  LATVIA = 'LV',
  LITHUANIA = 'LT',
  LUXEMBOURG = 'LU',
  MALTA = 'MT',
  MONTENEGRO = 'ME',
  NETHERLANDS = 'NL',
  NORTH_MACEDONIA = 'MK',
  NORWAY = 'NO',
  PANAMA = 'PA',
  POLAND = 'PL',
  PORTUGAL = 'PT',
  ROMANIA = 'RO',
  RUSSIA = 'RU',
  SERBIA = 'RS',
  SLOVAKIA = 'SK',
  SLOVENIA = 'SI',
  SPAIN = 'ES',
  SWEDEN = 'SE',
  UKRAINE = 'UA',
  UNITED_ARAB_EMIRATES = 'AE',
  UNITED_KINGDOM = 'GB',
  UNITED_STATES = 'US',
}
